module.exports = __webpack_public_path__ + "assets/img/zhone.a31e7ff3.png";